<template>
    <div class="challenge-container">
        <div class="outbox technicalarticles">
            <div class="challenge-header">
                <div class="title df aic jcc">
                    <el-button type="primary" class="h-46 fs-20 pl-36 pr-36" v-throttle="2000" @click="goNewSubmit">
                        {{ $t('发布短视频') }}
                    </el-button>
                </div>

                <template v-if="publishedList.length">
                    <div class="title published-heading">{{ $t('已发布短视频') }}<template v-if="publishedList.length"> ({{ publishedList.length }})</template></div>
                    <div v-for="row in publishedList" :key="row.tasqs_id" class="line df aic">
                        <div class="l1 f1">
                            <div class="df aic">
                                <el-input readonly :value="row.tasqs_video_title || ''" :placeholder="$t('请填写短视频')" />

                                <div class="fn btn-col ml-24 df aic">
                                    <!--   -->
                                    <el-button type="primary" v-if="row.tasqs_status === 'error'"
                                        @click="goResubmit(row.tasqs_id)">{{ $t('修改重提') }}</el-button>
                                    <el-button v-if="showThirdPartyProofButton(row)" type="primary"
                                        :disabled="!canOpenProofForm(row)" @click="openProofDialog(row)">{{
                                        proofActionButtonText(row) }}</el-button>
                                    <el-button v-if="isProofReadonly(row)" type="primary" plain
                                        @click="openProofView(row)">{{ $t('查看举证') }}</el-button>
                                </div>
                            </div>
                            <div class="row-status row-status-inline df aic">
                                <span class="row-status-seg df aic">
                                    <span>{{ $t('视频审核') }}：</span>
                                    <span class="status-item" :class="mainStatusBadgeClass(row.tasqs_status)">{{ mainStatusText(row.tasqs_status) }}</span>
                                </span>
                                <span v-if="row.tasqs_status === 'success'" class="row-status-seg df aic row-status-seg-proof">
                                    <span>{{ $t('三方举证审核') }}：</span>
                                    <span class="status-item" :class="proofStatusBadgeClass(row)">{{ proofStatusText(row.tasqs_proof_status || 'none') }}</span>
                                </span>
                            </div>
                        </div>

                    </div>
                </template>

                <div v-if="paper.tasp_content" class="introduction" v-html="paper.tasp_content"></div>
            </div>
        </div>

        <el-dialog :title="$t('第三方平台举证')" :visible.sync="proofDialogVisible" width="680px" @close="resetProofForm">
            <el-form label-position="top" :rules="proofRules" ref="proofFormRef">
                <el-form-item :label="$t('第三方平台视频链接')" prop="proof_link">
                    <el-input v-model="proofForm.proof_link" :placeholder="$t('请填写链接')"></el-input>
                </el-form-item>
                <el-form-item :label="$t('举证截图')" prop="proof_images_raw">
                    <Upload :key="proofUploadKey" v-model="proofForm.proof_images_raw" upType="IMGARR"
                        :fileType="['jpg', 'jpeg', 'png', 'gif', 'webp']" :isUseOss="true" :fileLimit="9" />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="proofDialogVisible = false">{{ $t('取消') }}</el-button>
                <el-button type="primary" v-throttle="1500" @click="submitProof">{{ $t('提交') }}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="$t('举证信息')" :visible.sync="proofViewVisible" width="560px">
            <template v-if="proofViewRow">
                <p><strong>{{ $t('链接') }}：</strong>
                    <el-link v-if="proofViewRow.tasqs_proof_link" type="primary" :href="proofViewRow.tasqs_proof_link"
                        target="_blank" rel="noopener">{{ proofViewRow.tasqs_proof_link }}</el-link>
                    <span v-else>—</span>
                </p>
                <p class="proof-imgs-label">{{ $t('举证截图') }}：</p>
                <div v-if="proofImageUrls(proofViewRow).length" class="proof-img-grid">
                    <el-image v-for="(u, i) in proofImageUrls(proofViewRow)" :key="i" class="proof-thumb"
                        :src="resolveProofImageUrl(u)" :preview-src-list="proofImagePreviewSrcList(proofViewRow)"
                        fit="cover" />
                </div>
                <p v-else class="proof-no-imgs">{{ $t('暂无举证截图') }}</p>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import Upload from '@/components/Upload/index';
import { taskDetailList, shortVideoProofSubmit } from '@/api/challenge';

const SHORT_VIDEO_PROOF_IMAGE_MAX = 9;

export default {
    name: 'ChallengeShortVideoList',
    components: { Upload },
    data() {
        return {
            paper: {},
            publishedList: [],
            proofDialogVisible: false,
            proofViewVisible: false,
            proofTarget: null,
            proofViewRow: null,
            proofForm: {
                proof_link: '',
                proof_images_raw: [],
            },
            proofUploadKey: 0,

            proofRules: {
                proof_link: [
                    { required: true, message: this.$t('请填写第三方平台视频链接'), trigger: 'blur' },
                ],
                proof_images_raw: [
                    { required: true, message: this.$t('请上传举证截图'), trigger: 'change' },
                ],
            },
        };
    },
    computed: {
        ta_id() {
            return this.$route.params.ta_id;
        },
        tas_id() {
            return this.$route.params.tas_id;
        },
        tasp_id() {
            return this.$route.params.tasp_id;
        },
    },
    mounted() {
        this.getData();
    },
    methods: {
        langPrefix() {
            let str = '/cn';
            const Language = localStorage.getItem('currentLanguage');
            if (Language && Language !== 'zh') {
                str = '/' + Language;
            }
            return str;
        },
        postDetailHref(tpId) {
            return this.langPrefix() + '/discuss/info/' + tpId;
        },
        goNewSubmit() {
            const loc = {
                name: 'CHALLENGE_SHORTVIDEOSUB',
                params: {
                    ta_id: this.ta_id,
                    tas_id: this.tas_id,
                    tasp_id: this.tasp_id,
                },
            };
            this.$router.push(loc).catch((err) => {
                if (err.name !== 'NavigationDuplicated') throw err;
            });
        },
        goResubmit(tasqsId) {
            const loc = {
                name: 'CHALLENGE_SHORTVIDEOSUB',
                params: {
                    ta_id: this.ta_id,
                    tas_id: this.tas_id,
                    tasp_id: this.tasp_id,
                },
                query: { tasqs_id: String(tasqsId) },
            };
            this.$router.push(loc).catch((err) => {
                if (err.name !== 'NavigationDuplicated') throw err;
            });
        },
        mainStatusBadgeClass(s) {
            if (s === 'wait') return 'status-wait';
            if (s === 'success') return 'status-success';
            if (s === 'error') return 'status-rejected';
            return '';
        },
        proofStatusBadgeClass(row) {
            const p = (row && row.tasqs_proof_status) || 'none';
            if (p === 'wait') return 'status-wait';
            if (p === 'success') return 'status-success';
            if (p === 'error') return 'status-rejected';
            return 'status-muted';
        },
        mainStatusText(s) {
            const m = {
                wait: this.$t('审核中'),
                success: this.$t('审核通过'),
                error: this.$t('已驳回'),
            };
            return m[s] || s;
        },
        proofStatusText(s) {
            const m = {
                none: this.$t('举证未提交'),
                wait: this.$t('举证审核中'),
                success: this.$t('举证已通过'),
                error: this.$t('已驳回'),
            };
            return m[s] || s;
        },
        canOpenProofForm(row) {
            return row.tasqs_status === 'success'
                && ['none', 'error'].indexOf(row.tasqs_proof_status || 'none') >= 0;
        },
        /** 举证已全部通过时只看「查看举证」，不显示本按钮 */
        showThirdPartyProofButton(row) {
            return !this.isProofReadonly(row);
        },
        isProofReadonly(row) {
            return row.tasqs_status === 'success' && row.tasqs_proof_status === 'success';
        },
        proofActionButtonText(row) {
            if ((row.tasqs_proof_status || 'none') === 'error') {
                return this.$t('重新举证');
            }
            return this.$t('第三方平台发布举证');
        },
        proofImageUrls(row) {
            return this.parseProofImagesRaw(row && row.tasqs_proof_images);
        },
        /** 后端常存 storage/... 相对路径，须补成根路径否则会从当前路由目录解析导致加载失败 */
        resolveProofImageUrl(p) {
            const s = String(p == null ? '' : p).trim();
            if (!s) {
                return '';
            }
            if (/^https?:\/\//i.test(s) || s.startsWith('//')) {
                return s;
            }
            if (s.startsWith('/')) {
                return s;
            }
            return `/${s.replace(/^\/+/, '')}`;
        },
        proofImagePreviewSrcList(row) {
            return this.proofImageUrls(row).map((u) => this.resolveProofImageUrl(u));
        },
        /** TryUpload 的 v-model 需要 JSON 字符串：[{att_id,att_title,att_url}]；att_url 用可预览的绝对路径 */
        buildUploadJsonFromProofRow(row) {
            const urls = this.proofImageUrls(row).slice(0, SHORT_VIDEO_PROOF_IMAGE_MAX);
            if (!urls.length) {
                return null;
            }
            const base = Date.now();
            const imgs = urls.map((url, i) => ({
                att_id: base + i,
                att_title: `proof-${i + 1}.jpg`,
                att_url: this.resolveProofImageUrl(url),
            }));
            return JSON.stringify(imgs);
        },
        /** 提交接口仍用后端习惯的 storage/...；Upload 回显可能带 /storage/ 或完整 OSS 地址 */
        normalizeProofImagePathForApi(p) {
            const s = String(p == null ? '' : p).trim();
            if (!s) {
                return '';
            }
            if (/^https?:\/\//i.test(s) || s.startsWith('//')) {
                return s;
            }
            if (s.startsWith('/storage/')) {
                return s.slice(1);
            }
            return s;
        },
        openProofDialog(row) {
            if (!this.canOpenProofForm(row)) {
                return;
            }
            this.proofTarget = row;
            if ((row.tasqs_proof_status || 'none') === 'error') {
                this.proofForm = {
                    proof_link: row.tasqs_proof_link || '',
                    proof_images_raw: this.buildUploadJsonFromProofRow(row),
                };
            } else {
                this.proofForm = { proof_link: '', proof_images_raw: null };
            }
            this.proofUploadKey += 1;
            this.proofDialogVisible = true;
        },
        openProofView(row) {
            this.proofViewRow = row;
            this.proofViewVisible = true;
        },
        resetProofForm() {
            this.proofTarget = null;
            this.proofForm = { proof_link: '', proof_images_raw: null };
        },
        parseProofImagesRaw(raw) {
            if (!raw) {
                return [];
            }
            let arr = raw;
            if (typeof raw === 'string') {
                try {
                    arr = JSON.parse(raw);
                } catch (e) {
                    return [];
                }
            }
            if (!Array.isArray(arr)) {
                return [];
            }
            return arr
                .map((x) => {
                    if (typeof x === 'string') {
                        return x.trim();
                    }
                    if (x && typeof x === 'object') {
                        return String(x.att_url || x.url || '').trim();
                    }
                    return '';
                })
                .filter(Boolean);
        },
        async submitProof() {

            
            if (!this.proofTarget) {
                return;
            }
            const link = (this.proofForm.proof_link || '').trim();
            const images = this.parseProofImagesRaw(this.proofForm.proof_images_raw)
                .map((p) => this.normalizeProofImagePathForApi(p))
                .filter(Boolean);
            if (!link) {
                this.$message.error(this.$t('请填写三方平台视频链接'));
                return;
            }
            if (!images.length) {
                this.$message.error(this.$t('请上传举证截图'));
                return;
            }
            if (images.length > SHORT_VIDEO_PROOF_IMAGE_MAX) {
                this.$message.error(this.$t('举证截图最多上传9张'));
                return;
            }
            const loading = this.$loading({
                lock: false,
                text: this.$t('加载中'),
                background: 'rgba(0, 0, 0, 0.1)',
            });
            try {
                const res = await shortVideoProofSubmit({
                    ta_id: this.ta_id,
                    tasqs_id: this.proofTarget.tasqs_id,
                    proof_link: link,
                    proof_images: images,
                });
                loading.close();
                if (res.status === 200) {
                    this.$message.success(this.$t('提交成功'));
                    this.proofDialogVisible = false;
                    this.getData();
                }
            } catch (e) {
                loading.close();
            }
        },
        async getData() {
            try {
                const res = await taskDetailList({
                    ta_id: this.ta_id,
                    tas_id: this.tas_id,
                    tasp_id: this.tasp_id,
                });
                if (res.status === 200 && res.data) {
                    if (res.data.status === false) {
                        this.$message.error(res.data.msg);
                        return;
                    }
                    this.paper = res.data.paper || {};
                    this.publishedList = res.data.published_short_videos || [];
                }
            } catch (e) {
                /* 401/4002 由请求封装处理 */
            }
        },
    },
};
</script>

<style lang="scss" scoped>
/* 与 shortvideo_old.vue 对齐 */
.outbox {
    min-width: 840px;
    max-width: 1680px;
    margin: 0 auto 16px;
    background: #fff;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    box-sizing: border-box;
    padding: 32px 32px 0;

    &:last-child {
        margin-bottom: 0;
    }
}
::v-deep{
    .upload-demo .el-upload--picture-card{
        width: 148px;

    }
}
.challenge-container {
    width: 100%;
    padding: 80px 120px 20px;
    background: #f9f9f9;
    min-height: 100vh;
    color: #191919;

    .technicalarticles {
        padding-bottom: 32px;
    }

    .challenge-header {
        margin-bottom: 12px;

        .title {
            font-size: 26px;
            line-height: 30px;
            margin-bottom: 26px;
        }

        .introduction {
            font-size: 14px;
            line-height: 24px;
            font-weight: 300;
            color: #595959;
            margin-top: 24px;
            margin-bottom: 20px;
        }

        .published-heading {
            margin-top: 8px;
            margin-bottom: 16px;
        }
    }
}

.line {
    margin-bottom: 26px;

    &:last-child {
        margin-bottom: 0;
    }

    .l1 {
        margin-right: 20px;
        min-width: 0;

        ::v-deep .el-input__inner {
            height: 40px;
            border: 0;
            border-bottom: 1px solid #dddddd;
            padding: 0;
        }
    }

    .btn-col {
        gap: 8px;
    }

    .btn-col .el-button+.el-button {
        margin-left: 0;
    }
}

.row-status {
    margin-top: 8px;
    font-size: 12px;
    line-height: 20px;
    color: #707070;

    &.row-status-inline {
        flex-wrap: nowrap;
        gap: 20px;
        min-width: 0;
    }

    .row-status-seg {
        flex-shrink: 0;
        white-space: nowrap;
    }

    .row-status-seg-proof {
        padding-left: 4px;
    }

    .status-item {
        display: inline-block;
        padding: 0 6px;
        border-radius: 4px;
        font-size: 12px;
        line-height: 20px;
        vertical-align: middle;

        &.status-wait {
            background: rgba(10, 89, 247, 0.1);
            color: #0a59f7;
        }

        &.status-success {
            background: rgba(92, 128, 89, 0.12);
            color: #5c8059;
        }

        &.status-rejected {
            background: rgba(217, 72, 56, 0.12);
            color: #d94838;
        }

        &.status-muted {
            background: rgba(0, 0, 0, 0.06);
            color: #595959;
        }
    }

    .status-sep {
        margin: 0 6px;
        color: #bfbfbf;
    }

    .status-link {
        margin-left: 12px;
        color: #0067d1;
    }
}

.proof-imgs-label {
    margin: 12px 0 8px;
    font-weight: 600;
}

.proof-no-imgs {
    margin: 8px 0 0;
    font-size: 13px;
    color: #909399;
}

.proof-img-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;

    .proof-thumb {
        width: 120px;
        height: 120px;
        border-radius: 4px;
    }
}
</style>
